import React from "react";
import Textarea from "./Textarea";
import Translation from "../classes/Translation";
import styled from "styled-components";
import CreatorModal from "./CreatorModal";
import CreatorPreview from "./CreatorPreview";
import SentencesBank from "./SentencesBank";
import TemplateBank from "./TemplateBank";
import Helper from "../classes/Helper";
import ImageThumbList from "./ImageThumbList";
import SnapshotGenerator from '../classes/SnapshotGenerator';
import Api from "../classes/Api";
import {MatVariatSelect, VariantsSelect} from "./VariantsSelect";
import ErrorAlert from './ErrorAlert';

const InputWrapper = styled.div`
    display: ${props => {return props.display === "true" ? "block" : "none"}};
`;

    const P = styled.p`
        user-select: none;
        float: left;
        padding-top: 2px;
        font-weight: 400;
    `;

export default class CustomizationWrapper extends React.PureComponent{
    constructor(props){
        super(props);
        this.state = {
            clickedTabIndex: undefined,
            tabClicked: false,
            customizedTabIndex: [],
            selectedCheckboxesIndex: [],
            previewClicked: undefined,
            sentencesBankClicked: [],
            sentencesBankVisible: [],
            templateBankClicked: [],
            templateBankVisible: [],
            continueButton: true,
            motivs: [],
            customerImageLayers: []
        };

        this.checkboxRefs = [];
        this.grawerStateInputRefs = [];
    }

    componentDidUpdate(){
        SnapshotGenerator.renderThumbnails(this.props.projects);
    }

    componentDidMount(){
        //if product has one TAB we need to render only text inputs ;)
        if(Object.keys(this.props.projects).length === 1){
            this.setState({
                continueButton: false,
                customizedTabIndex: [0],
                tabClicked: true,
                clickedTabIndex: 0
            })
        }
        this.findLayersWithcustomerImageLayers();
        this.createRefs();
        this.setSelectedCheckboxes();
        this.getMotivs();
        this.props.hideLoadingImage();
    }

    getMotivs = () => {
        Object.keys(this.props.projects).forEach((projectKey) => {
            let layers = this.props.projects[projectKey].stage.getLayers();
            layers.forEach((layer, layerKey) => {
                let content = layer.findOne(".content");
                let objectType = layer.getAttr('object_type');
                if(['image'].includes(objectType)){
                    if(content.getAttr('motiv_group') && content.getAttr('motiv_group') != "0"){
                        Api.getMotivs(content.getAttr('motiv_group'), Translation.getSelectedLanguage())
                        .then(data => data.json())
                        .then(json => {
                            let object = {
                                layerid: layer.id(),
                                elements: json,
                            };

                            this.setMotivProperties(projectKey, json, content);
                            this.setState((prevState) => ({
                                motivs: [...prevState.motivs, object]
                            }));
                        })
                    }
                }
                
            });
        });
    }
    
    setMotivProperties = (projectKey, json, content) => {
        //if there is a property of default_motiv on product, override
        if(this.props.projects[projectKey].default_motiv && this.props.projects[projectKey].default_motiv != "0"){
            json.forEach(motiv => {
                if(motiv.id_projects_motiv == this.props.projects[projectKey].default_motiv){
                    motiv.selected = true;
                    this.props.projects[projectKey].id_motiv = motiv.id_projects_motiv;
                    this.props.projects[projectKey].id_production_category = motiv.id_production_category;
                }else{
                    motiv.selected = false;
                }
            });
        }
        else{//it there isn't default_motiv has been set on product set default_motiv that set on project
            json.forEach(motiv => {
                if(motiv.id_projects_motiv == content.getAttr('default_motiv')){
                    motiv.selected = true;
                    this.props.projects[projectKey].id_motiv = motiv.id_projects_motiv;
                    this.props.projects[projectKey].id_production_category = motiv.id_production_category;
                }else{
                    motiv.selected = false;
                }
            });
        }
    }

    createRefs = () => {
        Object.keys(this.props.projects).map(() => {
            this.checkboxRefs.push(React.createRef());
            this.grawerStateInputRefs.push(React.createRef());
        })
    }

    setSelectedCheckboxes = () => {
        Object.keys(this.props.projects).map((index) => {
            if(this.props.projects[index]['grawer_state'] == "1"){
                this.setState((prevState) => ({
                    selectedCheckboxesIndex: [...prevState.selectedCheckboxesIndex, index]
                }));
            }
        })

    }

    hideDomElements = (hide = true) => {
        const selector = `
            .save-creator,
            .product-group-select,
            .discountBoxProductLabel,
            .add,
            #delivery_info
        `;

        const elements = document.querySelectorAll(selector);
        if(elements){
            elements.forEach(element => {
                if(hide){
                    element.dataset.cssdisplay = getComputedStyle(element)['display'];
                    element.style.display = 'none';
                }else{
                    element.style.display = element.dataset.cssdisplay;
                }
            });
        }
    }

    onClickCreatorTab = (event) => {
        event.stopPropagation();
        let tabindex = event.currentTarget.dataset.tabindex;
        this.state.clickedTabIndex = tabindex;
        this.slideTo(event);
        if(!this.state.customizedTabIndex.includes(tabindex))
            this.state.customizedTabIndex.push(tabindex);

        this.setState({
            tabClicked: true
        });
        this.hideDomElements(true);
    }

    slideTo = (event) => {
        let slideIndex = event.currentTarget.getAttribute('slideindex');
        this.props.carouselSwiper.slideTo(slideIndex);
    }

    onClickCustomizationCheckboxContainer = (event) => {
        let index = event.currentTarget.getAttribute('index');
        if(this.state.selectedCheckboxesIndex.includes(index)){
            this.setState({
                selectedCheckboxesIndex: this.state.selectedCheckboxesIndex.filter(element => element !== index)
            });
            this.hideOrUnhideAllCustomTextOnProject(this.props.projects[index], true, index);
        }else{
            this.setState({
                selectedCheckboxesIndex: [...this.state.selectedCheckboxesIndex, index] 
            });
            this.hideOrUnhideAllCustomTextOnProject(this.props.projects[index], false, index);
        }

        this.slideTo(event);
    }

    hideOrUnhideAllCustomTextOnProject = (project, hide, index) => {
        let layers = project.stage.getLayers();
        layers.map((layer, index) => {
            if(layer.getAttr("object_type") != "product"){
                if(layer.findOne('Group')){
                    if(hide){
                        layer.findOne('Group').visible(false);
                    }else{    
                        layer.findOne('Group').visible(true);
                    }
                }
            }
        })

        project.grawer_state = hide ? 0 : 1;
    }


    unhideTabs = (event) => {        
        if(Helper.isTestmode() || Helper.isFulledit() || window.warning_tab.filter(element => element[0] === event).length == 0) {
            this.setState({
                tabClicked: false
            })
            this.hideDomElements(false);
        }     
    }

    onClickPreview = (e) => {
        this.setState({
            previewClicked: true
        });
    }

    onClickSentencesBank = (e) => {
        let sentenceBankId = e.target.getAttribute('sentenceBankId');
        this.setState({
            sentencesBankClicked: [...this.state.sentencesBankClicked, sentenceBankId],
            sentencesBankVisible: [...this.state.sentencesBankClicked, sentenceBankId]
        })
    }

    onClickTemplateButton = (e) => {
        let templateBankId = e.target.getAttribute('templatebankid');
        this.setState({
            templateBankClicked: [...this.state.templateBankClicked, templateBankId],
            templateBankVisible: [...this.state.templateBankVisible, templateBankId]
        })
    }

    closeModal = (e, tabindex = undefined) => {
        if(tabindex != undefined){ //if not close modal from "X"
            this.setState((prevState) => ({
                sentencesBankVisible: [],
                templateBankVisible: [],
                previewClicked: false,
                motivs: [],
                selectedCheckboxesIndex: [...prevState.selectedCheckboxesIndex, `${tabindex}`],
                customerImageLayers: []
            }), () => {         
                this.getMotivs();
                this.findLayersWithcustomerImageLayers();
            });
        } else {
            this.setState({
                sentencesBankVisible: [],
                templateBankVisible: [],
                previewClicked: false
            });
        }
    }

    onSelectCarouselSwiper = (slideIndex) => {
        this.props.carouselSwiper.slideTo(slideIndex);
    }

    onChangeMotiv = (e, content, projectIndex) => {
        let selected = e.target.options[e.target.options.selectedIndex];
        let imagePath = selected.getAttribute("path");
        let id = selected.getAttribute('value');
        let idProductionCategory = selected.getAttribute('id_production_category');
        content.setAttr('image_src', imagePath);
        content.setAttr('default_motiv', id);
        this.props.projects[projectIndex]['id_motiv'] = id;
        this.props.projects[projectIndex]['id_production_category'] = idProductionCategory;
        content.load(()=>{
            content.draw();
            this.props.carouselSwiper.slideTo(this.props.projects[projectIndex].slideIndex);
            SnapshotGenerator.renderThumbnails(this.props.projects);        
        });

        this.forceUpdate();
    }

    image_source = (id) => {
        if(parseInt(id) > 0){
            var src="/img/p/";
            String(id).split("").forEach(function(key){ 
                src = src + key + "/";
            });        
            src = src + String(id) + ".jpg";                
            return src;
        }else
            return false;
    }

    onChangeVariant = (e, projectIndex) => {
        let selected_layer = this.props.projects[projectIndex].stage.findOne('.product');        
        if(selected_layer !== undefined){
            var image = selected_layer.findOne('.content');
            let src_product_image = this.image_source(e.target.selectedOptions[0].dataset.id_image);
            this.props.projects[projectIndex]['product_layer_id_product'] = e.target.value;
            this.props.projects[projectIndex]['product_layer_image'] = src_product_image;
            
            
            image.setAttr('image_src', src_product_image);
            document.querySelector('#custom_form_' + e.target.selectedOptions[0].dataset.id_stage + ' #id_variant').value = e.target.value;
            image.load(()=>{
                if(e.target.selectedOptions[0].dataset.id_texture){
                    this.props.projects[projectIndex]['product_layer_texture'] = this.image_source(e.target.selectedOptions[0].dataset.id_texture);
                    let layers = this.props.projects[projectIndex].stage.find('Layer');
                    for (var i = 0; i < layers.length; i++) {
                        if((layers[i].attrs.object_type == "text_normal" || layers[i].attrs.object_type == "image" || layers[i].attrs.object_type == "ellipse")){
                            var obj = layers[i].findOne('.content');
                            if(obj.getAttr('texture_type') != 'force'){
                                obj.attrs.texture_src = this.props.projects[projectIndex]['product_layer_texture'];
                                obj.load(()=>{
                                    obj.draw();
                                    image.draw();
                                    this.props.carouselSwiper.slideTo(this.props.projects[projectIndex].slideIndex);
                                    SnapshotGenerator.renderThumbnails(this.props.projects);          
                                });
                            }
                        }
                    }
                }else{
                    image.draw();
                    this.props.carouselSwiper.slideTo(this.props.projects[projectIndex].slideIndex);
                    SnapshotGenerator.renderThumbnails(this.props.projects);
                }              
            });
        }
        else
        {
            this.props.projects[projectIndex]['product_layer_id_product'] = e.target.value;
            document.querySelector('#custom_form_' + e.target.selectedOptions[0].dataset.id_stage + ' #id_variant').value = e.target.value;
            console.log("Error! Product's layer is not found");        
        }        
    }

    findLayersWithcustomerImageLayers = () => {
        this.props.projects.forEach((project, projectKey) => {
            project.stage.getLayers().forEach(layer => {
            if (layer.getAttr('customer_image') === true) {
                if (this.state.customerImageLayers[projectKey] === undefined) {
                this.state.customerImageLayers[projectKey] = [];
                }
                this.state.customerImageLayers[projectKey].push(layer);
            }
            });
            this.forceUpdate();
        });
    }

    getStageName(index) {
        return `${this.props.projects[index].id_project}_${this.props.projects[index].project_code}_${Date.now()}`;
    }

    isCustomerImage = (index) => {
        return this.state.customerImageLayers !== undefined
        && this.state.customerImageLayers.length > 0
        && this.state.customerImageLayers[index] !== undefined
        && this.state.customerImageLayers[index].length > 0;
    }

    render(){
        const { projects } = this.props;
        const { tabClicked, clickedTabIndex, continueButton,
            customizedTabIndex, selectedCheckboxesIndex, sentencesBankClicked, sentencesBankVisible, 
            previewClicked, templateBankClicked, templateBankVisible, motivs, customerImageLayers } = this.state;
        const tabs = (Object.keys(projects).length > 1 &&
        Object.keys(projects).map((index) => {
            const tabCustomized = customizedTabIndex.includes(index);
            return(
                <ul className="nav nav-tabs creator-tabs stretch">
                    <div className=
                    {
                        tabCustomized ? "nav-item customized" : "nav-item"
                    }    
                >
                        <a className="nav-link" key={index} data-tabindex={index} slideindex={projects[index].slideIndex} onClickCapture={this.onClickCreatorTab}>
                            {Translation.getTranslation('projects')[index].tabName}
                            <div className=
                                {
                                    !tabCustomized ? "customize_label" : "customized_label_check"
                                } 
                                >
                                <i className=
                                {
                                    "fa " + (!tabCustomized ? "fa-times" : "fa-check") 
                                }

                                />
                                {
                                    !tabCustomized ? 
                                        Translation.getTranslation('creatorTabCustomize') : Translation.getTranslation('creatorTabReady')  
                                }
                            </div>
                        </a>
                    </div>
                </ul>
            )
        }));

        const inputs = 
        Object.keys(projects).map((index) => {
            const inputsDisplay = tabClicked && clickedTabIndex == index ? true : false;
            const checkboxSelected = selectedCheckboxesIndex.includes(index) ? true : false;
            let templateBankId = index;
            return <InputWrapper 
                        id={`custom_form_` + projects[index].id_tab} 
                        key={index} 
                        className="custom_form form-content tab-pane"
                        display={inputsDisplay.toString()}    
                    >

                { projects[index].id_projects_groups > 0 &&
                    <div 
                        className="select_project_button btn-primary"
                        templatebankid={templateBankId}
                        onClick={this.onClickTemplateButton}
                    >
                        { projects[index].button_text.length > 0 && projects[index].active_button == 1 ? projects[index].button_text : Translation.getTranslation('buttonChangeDesign') }
                    </div>
                }
                { projects[index].id_projects_groups > 0 && templateBankClicked.includes(templateBankId) &&
                    <CreatorModal
                        closeModal={this.closeModal}
                        title={ projects[index].button_text.length > 0 && projects[index].active_button == 1 ? projects[index].button_text : Translation.getTranslation('buttonChangeDesign') }
                        visibility={templateBankVisible.includes(templateBankId)}
                        replaceProject={this.props.replaceProject}
                        content={
                            <TemplateBank
                                object={projects[index]}
                                selectedLanguage={Translation.getSelectedLanguage()}
                                closeModal={this.closeModal}
                                replaceProject={this.props.replaceProject}
                                tabindex={clickedTabIndex}
                            />
                        }
                    />
                }
                <input 
                    type="hidden" id="thumbnail_blob" 
                    name={"creator[" + projects[index]['id_tab'] + "][thumbnail_blob]"} 
                    value="0"
                />
                <input
                    ref={this.grawerStateInputRefs[index]}
                    type="hidden" id="grawer_state" 
                    name={"creator[" + projects[index]['id_tab'] + "][grawer_state]"} 
                    value={checkboxSelected ? "1" : "0"}
                />
                <input   
                    type="hidden"
                    id="creator_json"
                    name={"creator[" + projects[index]['id_tab'] + "][creator_json]"}
                    value="1"
                />
                <input  
                    type="hidden"
                    id="id_variant"
                    name={"creator[" + projects[index]['id_tab'] + "][id_variant]"}
                    value={projects[index]['product_layer_id_product']}
                />
                <input 
                    type="hidden"
                    id="id_project"
                    name={"creator[" + projects[index]['id_tab'] + "][id_project]"}
                    value={projects[index]['id_project']}
                />
                <input 
                    type="hidden"
                    id="id_production_category"
                    name={"creator[" + projects[index]['id_tab'] + "][id_production_category]"}
                    value={projects[index]['id_production_category']}
                />
                <input 
                    type="hidden"
                    id="id_motiv"
                    name={"creator[" + projects[index]['id_tab'] + "][id_motiv]"}
                    value={projects[index]['id_motiv'] ? projects[index]['id_motiv'] : 0}
                />
                {
                    customerImageLayers[index] && 
                    customerImageLayers[index].map(layer => {
                        return <input
                            maxLength={0}
                            type="hidden"
                            name={`creator[${projects[index]['id_tab']}][client_image_blobs][${layer.getAttr('script_label')}]`}
                            value={
                                layer.findOne('.content').imageObject ? 
                                    String(layer.findOne('.content').imageObject.currentSrc).startsWith("data:image/png") ?
                                    layer.findOne('.content').imageObject.currentSrc
                                    : ""
                                : ""
                            }
                        />

                    })
                }
                <div className="inputs">
                    { 
                        projects[index].stage &&
                        [...projects[index].stage.getLayers()].reverse().map((layer, layerKey) => {
                            let objectType = layer.getAttr('object_type');
                            let addToClientForm = layer.getAttr('addToClientForm');
                            let sentenceBankId = index + layerKey;
                            let content = layer.findOne(".content"); 
                            if(['text_normal', 'ellipse'].includes(objectType) && (!addToClientForm || addToClientForm=='add')){                                
                                if(content && projects[index].id_tab != this.props.hideIdTab){
                                    return(
                                        <>
                                            <div className="select_label">
                                                {content._getTextJSONLabel(Translation.getSelectedLanguage())}
                                            </div> 
                                            
                                            <Textarea
                                                key={`${content.getLayer().id()}`}
                                                name={`creator[${projects[index].id_tab}][layer_text_${content.getLayer().id()}]`}
                                                warning_name={`creator[${projects[index].id_tab}][warning_layer_text_${content.getLayer().id()}]`}
                                                object={content} 
                                                disabled={!checkboxSelected}
                                                onFocus={() => {
                                                    this.props.carouselSwiper.slideTo(projects[index].slideIndex);
                                                    SnapshotGenerator.renderThumbnails(projects);
                                                }}
                                                slideIndex = {projects[index].slideIndex}
                                                onFontChange = {this.onSelectCarouselSwiper}
                                                onChange={() => {
                                                    SnapshotGenerator.renderThumbnails(projects);
                                                }}
                                                height={
                                                    Helper.getClientInputHeight(
                                                        content._getTextJSONText(
                                                            Translation.getSelectedLanguage()
                                                        )
                                                    )
                                                }
                                                defaultValue={content._getTextJSONText(
                                                    Translation.getSelectedLanguage(),
                                                    layer.getAttr('script_label')
                                                )}
                                                id = {
                                                    content.sentence() == 1 && "sentence"
                                                }
                                                id_tab = {projects[index].id_tab}
                                            />
                                            {
                                                (content.sentence() == 1 || content._getTextJSONSentence(Translation.getSelectedLanguage()) == true) &&
                                                <div
                                                    id="sentences_bank" 
                                                    className="sentences_bank"
                                                    onClick={this.onClickSentencesBank}
                                                    sentenceBankId={sentenceBankId}
                                                >
                                                    {Translation.getTranslation(`changeSentence`)}
                                                </div>
                                            }
                                            { 
                                                (content.sentence() == 1 || content._getTextJSONSentence(Translation.getSelectedLanguage()) == true) && sentencesBankClicked.includes(sentenceBankId) && 
                                                <CreatorModal
                                                    closeModal={this.closeModal}
                                                    title={"Bank sentencji"}
                                                    visibility={sentencesBankVisible.includes(sentenceBankId)}
                                                    content={
                                                        <SentencesBank 
                                                            object={content}
                                                            selectedLanguage={Translation.getSelectedLanguage()}
                                                            closeModal={this.closeModal}
                                                        />
                                                    }
                                                />
                                            }
                                        </>
                                    )
                                }
                            }else if(['image'].includes(objectType)){
                                if(content.getAttr('motiv_group') && content.getAttr('motiv_group') != "0"){
                                    let label_motiv = "";
                                    let _motivs = motivs.map((motiv) => {
                                        if(layer.id() == motiv.layerid){
                                            return motiv.elements.map((element, key) => {
                                                let selected = element.selected ? true : false;
                                                label_motiv = element.label;
                                                return (
                                                    <option
                                                        value={element.id_projects_motiv}
                                                        path={element.client_path}
                                                        id_production_category={element.id_production_category}
                                                        selected={selected}
                                                        data-selected={selected}
                                                    >
                                                        {element.name}
                                                    </option>
                                                );
                                            })
                                        }
                                    });
                                    return (
                                        <>
                                            <div className="select_label">                             
                                                {label_motiv}
                                                {/* {Translation.getTranslation('defaultInputLabel')} */}
                                            </div>
                                            <select
                                                onChange={(e) => {
                                                    this.onChangeMotiv(e, content, index);
                                                }}
                                                name={`creator[${projects[index].id_tab}][layer_motiv_${content.getLayer().id()}]`} 
                                                class="creator_input creator_input form-control"
                                            >
                                                { _motivs }
                                            </select>
                                        </>
                                    );
                                }
                            }
                        })
                    }
                </div>
                
                <VariantsSelect
                    project = { projects[index] }
                    image_source = { this.image_source}
                    onChange={(e) => {
                        this.onChangeVariant(e, index);                        
                    }}
                />

                <MatVariatSelect
                    project = { projects[index] }
                />
                
                {this.isCustomerImage(index) &&
                    <ImageThumbList 
                        stageId={projects[index].id_project} 
                        customerImageLayers={this.state.customerImageLayers[index]}
                        rerenderCustomizationInputs={(callback) => this.forceUpdate(callback)}
                        slideCarouselToIndexOnClick={() => this.props.carouselSwiper.slideTo(projects[index].slideIndex)}
                        
                    />
                }                   
                <div id="without_grawer">
                    <label
                        className="chk_container"
                        index={index}
                        onClick={this.onClickCustomizationCheckboxContainer}
                        slideindex={projects[index].slideIndex}
                    >
                        <i
                            ref={this.checkboxRefs[index]}
                            className={ checkboxSelected ? "fa chk_selected fa-check" : "fa deselected"}  
                        />
                        <P>
                            {
                                Translation.getTranslation('iWantPersonalization')
                            }
                        </P>
                    </label>
                </div>
                <div 
                    id="show_grawer" 
                    onClick={this.onClickPreview}
                    data-slideIndex={projects[index].slideIndex}

                >
                    <div className="btn btn-primary btn-preview"> 
                        {
                            Translation.getTranslation('preview')
                        } 
                    </div>
                </div>
                { continueButton &&
                    <div className="select_from_group">
                        <div className="btn btn-primary continue-btn" onClick={() => this.unhideTabs(projects[index].id_tab)}> 
                            { Translation.getTranslation('creatorTabNextBtn') }
                        </div>
                    </div>
                }
              
            </InputWrapper>
        });

        return (
            <React.Fragment>
                { !tabClicked && tabs}
                { inputs }
                { previewClicked && 
                    <CreatorModal
                        closeModal={this.closeModal}
                        visibility={true}
                        title={ Translation.getTranslation('preview') }
                        content={
                            <CreatorPreview
                                closeModal={this.closeModal}
                                closeButtonText={Translation.getTranslation('close')}
                                clickedTabIndex={clickedTabIndex}
                            />
                        }
                    />
                }      
                <ErrorAlert />          
            </React.Fragment>
        )
    }
}